<template>
  <div class="calendar">
    <div class="tipoSeletor">
      <v-btn class="period-selector" text large @click="changeView('dayGridMonth')"
             :class="view === 'dayGridMonth' ? 'active' : ''">Mês
      </v-btn>

      <v-btn id="header-semana" class="period-selector" text large @click="changeView('dayGridWeek')"
             :class="view === 'dayGridWeek' ? 'active' : ''">Semana
      </v-btn>

      <v-btn class="period-selector" text large @click="changeView('timeGridDay')"
             :class="view === 'timeGridDay' ? 'active' : ''">Dia
      </v-btn>

      <b-tooltip disabled ref="tooltip5" target="header-semana" placement="bottom" custom-class="tooltip-tutorial">
        <button type="button" class="close" aria-label="Close" @click="$refs.tooltip5.$emit('close')">
          <span aria-hidden="true">&times;</span>
        </button>
        <p class="titulo">Planner semanal e diário</p>
        <p class="conteudo">Prefere ver seus cronogramas de outra forma? Selecione semana ou dia para trocar a visualização.</p>
        <div class="footer">
          <p>5 de 5</p>
          <v-btn rounded class="btn primary-button" color="#FFFFFF" @click="onBoardingNext(6)">
            Fechar
          </v-btn>
        </div>
      </b-tooltip>
    </div>
    <div v-if="showConfirmDrop" class="confirm-drag-n-drop d-flex flex-sm-row justify-content-between align-items-center">
      <span>O conteúdo {{eventChanged.event.extendedProps.curso}} do dia {{formatDate(eventLatest.event.start)}} foi alterado para {{formatDate(eventChanged.event.start)}} </span> 
      <span>
        <strong><a @click="undoEventChange()">Desfazer</a></strong>
        <a @click="closeEventDrop()" ><i class="mdi mdi-close"></i></a>
      </span>
       
    </div>
    <full-calendar id="card-dia" class="full-calendar" :options="config" ref="fullCalendar" :style="minimumHeight">
      <template #eventContent="{ event }">
        <event-content :id="parseInt(event.id)" :course="event.extendedProps" :resumed="view !== 'timeGridDay'"
                       :color="scheduleColor(event.start)"/>
      </template>

      <template #dayCellContent="{date, dayNumberText}">
        <day-cell-content :day-number-text="dayNumberText" :courses="daySchedule(date)" :color="scheduleColor(date)"
                          @change-view="params => changeView(params.view, params.start)" :date="date"/>
      </template>

      <template #dayHeaderContent="{date, isToday, text}">
        <day-header :weekday-text="text" :is-today="isToday" :day-number="dayHeaderNumber(date)"/>
      </template>
    </full-calendar>

    <b-tooltip disabled ref="tooltip4" target="card-dia" placement="bottom" custom-class="tooltip-tutorial">
      <button type="button" class="close" aria-label="Close" @click="$refs.tooltip4.$emit('close')">
        <span aria-hidden="true">&times;</span>
      </button>
      <p class="titulo">Visualização mensal</p>
      <p class="conteudo">Aproveite seu calendário para visualizar sua organização de estudos!</p>
      <div class="footer">
        <p>4 de 5</p>
        <div class="d-flex align-items-center">
          <p class="voltar" @click="onBoardingReturn(3)">Voltar</p>
          <v-btn rounded class="btn primary-button" color="#FFFFFF" @click="onBoardingNext(5)">
            Próxima dica
          </v-btn>
        </div>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import './style.scss'
import '@fortawesome/fontawesome-free/css/all.css';
import '@fullcalendar/core/vdom' // solve problem with Vite
import 'bootstrap/dist/css/bootstrap.css';

import FullCalendar from '@fullcalendar/vue'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'

import {isBefore, startOfToday} from 'date-fns'
import DateUtils from "@/core/utils/date-utils";
import DayCellContent from "./dayCellContent";
import DayHeader from "./dayHeader";
import EventContent from "./eventContent";
import MaterialUtils from "@/core/utils/material-utils";

export default {
  name: 'Calendar',

  components: {
    DayHeader,
    EventContent,
    FullCalendar,
    DayCellContent,
  },

  data() {
    return {
      view: 'dayGridMonth',
      showConfirmDrop: false,
      eventChanged: [],
      eventLatest: [],
      topicTypes: [
        '',
        'Vídeo',
        'Texto',
        'Imagem',
        'Questão',
        'Questão Discursiva',
        'Apostila',
        'Dummy',
        'Laboratório Virtual',
        'Experiência Imersiva',
        'Quiz',
        'Formulário Avaliativo',
      ],
      calendarOptions: {
        editable: true,
        selectable: false,
        selectMirror: true,
        events: this.events,
        dayMaxEvents: 10,
        allDayText: '',
        weekends: true,
        eventOrder: 'id',
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrapPlugin],
        themeSystem: 'bootstrap',
        allDaySlot: true,
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next'
        },
        titleFormat: {
          year: 'numeric',
          month: 'long'
        },
        displayEventTime: false,
        dayHeaderFormat: {
          weekday: 'short',
          omitCommas: true
        },
        bootstrapFontAwesome: {
          next: 'angle-right',
          prev: 'angle-left',
        },
        moreLinkContent: function () {
          return '';
        },
        initialView: 'dayGridMonth'
      }
    }
  },

  mounted() {
    this.$refs.fullCalendar.getApi().setOption('locale', 'pt-br')

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    ...mapGetters(['agenda', 'currentDay', 'dateRange']),

    minimumHeight() {
      return this.view === 'dayGridWeek' && window.screen.width < 1024 ? {minHeight: '730px'} : {minHeight: '500px'}
    },

    events() {
      let calendarEvents = []
      let courseQuestions = []
      let index = 0
      if (this.agenda.length > 0) {
        let urlEmpresa = window.location.origin
        this.agenda.forEach(schedule => {
          schedule.eventos_agenda.forEach(eventDay => {
            const start = new Date(eventDay.data_inicio.replace(/-/g, '/'))
            const end = new Date(eventDay.data_fim.replace(/-/g, '/'))
            eventDay.cursos.forEach(course => {
              let event = {
                ...course,
                allDay: true,
                description: 'dia',
                eventDayId: eventDay.id,
                scheduleId: schedule.id,
                start,
                end,
              }

              event.modulos.forEach(module => {
                module.tarefas.forEach(task => {
                  if (task.status === 'incompleta') {
                    if (isBefore(start, startOfToday())) {
                      task.status = 'atrasada'
                    }
                  }

                  if (task.concluido) {
                    task.status = 'completa'
                  }

                  let customUrl
                  let title
                  if (module.id) {
                    customUrl = urlEmpresa + '/sala-de-aula/' + course.referencia + '/'
                        + module.referencia + '/' + task.licao.referencia + '/' + task.topico.referencia

                    const taskTopicArray = [1, 2, 6, 9]
                    if (taskTopicArray.indexOf(task.tipo_topico_id) !== -1) {

                      title = task.topico.topico

                    } else if (task.tipo_topico_id === 4) {

                      let questionNumber = courseQuestions[task.licao.id]
                      courseQuestions[task.licao.id] = !questionNumber ? 1 : questionNumber + 1
                      title = 'Questão ' + courseQuestions[task.licao.id] + ' - ' + task.licao.licao

                    } else {
                      title = this.topicTypes[task.tipo_topico_id]
                    }
                  } else if (task.simulado) {

                    customUrl = urlEmpresa + '/simuladoprova/' + task.simulado_modelo_id
                    title = 'Simulado: ' + task.simulado

                  } else if (task.extensao) {

                    customUrl = task.url.includes("apostila-web") !== false
                        ? process.env.VUE_APP_BASE_FILES_URL + task.url
                        : process.env.VUE_APP_BASE_FILES_URL + 'apostila-web/' + task.url
                    title = 'Resumo: ' + task.titulo

                    task.isPdf = true
                    task.pdfId = task.tarefa_id
                  }

                  const {icon, material} = MaterialUtils.recoverMaterialType(task.material_id)

                  task.concluded = task.concluido === 1
                  task.customUrl = customUrl
                  task.icon = icon
                  task.isPdf = false
                  task.material = material
                  task.title = title
                })
              })
              event.index = index++
              calendarEvents.push(event)
            })
          })
        })
      }

      return calendarEvents
    },

    config() {
      return {
        ...this.calendarOptions,
        ...this.eventHandlers
      }
    },

    eventHandlers() {
      return {
        select: this.onDateSelect,
        datesSet: this.onDatesSet,
        refetchEvents: this.refetchEvents,
        eventDrop: this.eventDrop,
        eventDragStart: this.eventDragStart
      }
    },
  },

  watch: {
    events(value) {
      this.calendarOptions.events = value
    },

    currentDay(value) {
      this.changeView(this.view, value)
    }
  },

  methods: {
    ...mapActions([
      'deleteCronograma',
      'getAgenda',
      'loadTasksStatusChanges',
      'removeEventDay',
      'setCurrentDay',
      'setDateRange',
      'updateScheduleDates',
      'updateEventDay'
    ]),

    onResize() {
      this.windowWidth = window.innerWidth
    },

    changeView(gridView, data) {
      switch (gridView) {
        case 'timeGridDay': {
          this.calendarOptions.titleFormat = {year: 'numeric', month: 'long', day: 'numeric'}
          this.calendarOptions.dayMaxEvents = 500
          break
        }
        case 'dayGridWeek': {
          this.calendarOptions.titleFormat = {year: 'numeric', month: 'long'}
          this.calendarOptions.dayMaxEvents = 10
          this.loadTasksStatusChanges()
          break
        }
        default: {
          this.calendarOptions.titleFormat = {year: 'numeric', month: 'long'}
          this.calendarOptions.dayMaxEvents = 2
          this.loadTasksStatusChanges()
        }
      }

      this.view = gridView
      this.$refs.fullCalendar.getApi().changeView(gridView, data)
    },

    daySchedule(date) {
      const daySchedule = []

      this.events.forEach((course) => {
        if (date.getTime() === course.start.getTime()) {
          daySchedule.push(course)
        }
      })
      return daySchedule
    },

    scheduleColor(date) {
      let color = '#7C56F6'

      if (this.agenda.length > 0 && date) {
        this.agenda.forEach(schedule => {
          const isScheduleDay = DateUtils.getDifference(schedule.data_inicio, date) <= 0
              && DateUtils.getDifference(schedule.data_fim, date) >= 0

          if (isScheduleDay) {
            color = schedule.cor ?? color
          }
        })
      }

      return color
    },

    dayHeaderNumber(date) {
      return this.view === 'dayGridWeek' ? DateUtils.formatDate(date, 'DD') : ''
    },

    onDateSelect(value) {
      this.setCurrentDay(value.start)
    },

    eventDrop: async function(event) {
      this.closeEventDrop()
      
      this.eventChanged = event
      
      let eventDay = {
        data_inicio: DateUtils.formatDate(event.event.start, 'YYYY-MM-DD HH:mm:ss'),
        data_fim: DateUtils.formatDate(DateUtils.lastHourFromDay(event.event.start), 'YYYY-MM-DD HH:mm:ss'),
        id: event.event.extendedProps.eventDayId
      }
      this.events[event.event.extendedProps.index].start = event.event.start
      this.events[event.event.extendedProps.index].end = DateUtils.lastHourFromDay(event.event.start).toDate()
      await this.updateEventDay(eventDay)
      this.showConfirmDrop = true
    },

    eventDragStart: function(event) {
      this.eventLatest = event
    },

    closeEventDrop: function() {
      this.showConfirmDrop = !this.showConfirmDrop
    },

    undoEventChange: async function() {
      let eventDay = {
        data_inicio: DateUtils.formatDate(this.eventLatest.event.start, 'YYYY-MM-DD HH:mm:ss'),
        data_fim: DateUtils.formatDate(DateUtils.lastHourFromDay(this.eventLatest.event.start), 'YYYY-MM-DD HH:mm:ss'),
        id: this.eventChanged.event.extendedProps.eventDayId
      }
      this.events[this.eventChanged.event.extendedProps.index].start = this.eventLatest.event.start
      this.events[this.eventChanged.event.extendedProps.index].end = DateUtils.lastHourFromDay(this.eventLatest.event.start).toDate()
      await this.updateEventDay(eventDay)
      this.closeEventDrop()
    },

    formatDate: function(date) {
      return DateUtils.formatDate(date, 'DD/MM/YYYY')
    },

    onDatesSet(payload) {
      const rangeData = {
        data_inicio: payload.startStr,
        data_fim: payload.endStr
      }

      if (!this.dateRange) {
        this.setDateRange(rangeData)
      } else {
        const withinRange = DateUtils.getDifference(this.dateRange.data_fim, rangeData.data_fim) >= 0
            && DateUtils.getDifference(this.dateRange.data_inicio, rangeData.data_inicio) <= 0

        if (!withinRange) {
          this.setDateRange(rangeData)
          this.getAgenda(rangeData)
        }
      }
    },

    onBoardingReturn: function (step) {
      this.$emit('onBoardingReturn', step)
    },

    onBoardingNext: function (step) {
      this.$emit('onBoardingNext', step)
    }
  }
}
</script>
